import { CardAPI, debug } from "aaa";
import { action, observable } from "mobx";
import { CardAPIClient } from "network/APIClient";
import { CardStore } from "stores/CardStore";
import { ContactsStore } from "stores/ContactsStore";
import { IPin, ISecuredInfoDisplayChannel } from "types/card";
import { ISigningInfo, ISigningResponse } from "types/signing";

export default class ShowCardDataStore {
    cardStore = new CardStore();
    contactsStore = new ContactsStore();

    @observable displayChannel?: ISecuredInfoDisplayChannel;
    @observable signInfo?: ISigningInfo;
    @observable isLoading: boolean = false;
    @observable signingResponse?: ISigningResponse;
    @observable pin?: IPin;
    @observable cardPAN = "";

    @action load = async (cardId: string) => {
        this.isLoading = true;

        await this.cardStore.loadCard(cardId);
        await this.contactsStore.load();
        await this.getCardDataDisplayChannel();

        this.isLoading = false;
    }

    @action getCardDataDisplayChannel = async () => {
        if (!this.cardStore.card) {
            return;
        }

        const target = CardAPI.getCardDataDisplayChannel();
        this.isLoading = true;

        try {
            const response = await CardAPIClient.requestType(target);
            this.displayChannel = response.securedInfoDisplayChannel;
        } catch (error) {
            debug.log("### getCardDataDisplayChannel failed");
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    @action getCardDataSignInfo = async () => {
        if (!this.cardStore.card) {
            return;
        }

        const target = CardAPI.postCardData(this.cardStore.card.id, this.contactsStore.selectedPhoneId);
        this.isLoading = true;

        try {
            const response = await CardAPIClient.requestType(target);
            this.signInfo = response.signInfo;
        } catch (error) {
            debug.log("### getCardDataSignInfo failed");
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    @action getCardData = async () => {
        if (!this.cardStore.card ||
            !this.signingResponse ||
            !this.signingResponse.domainServiceResponse.id) {
            return;
        }

        const target = CardAPI.getCardData(this.signingResponse.domainServiceResponse.id);
        const response = await CardAPIClient.requestType(target);

        this.cardPAN = response.securedInfo.find(info => info.securedInfoType === "CARD_PAN")?.encryptedData?.cipherText ?? "";

        debug.log("### getCardData success", this.pin);
    }
}



// WEBPACK FOOTER //
// ./src/components/showCardData/ShowCardDataStore.ts